"use strict";import{TopNav as e}from"./src/TopNav.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-top-nav",e);
//# sourceMappingURL=sp-top-nav.js.map
